export default {
  'cookieBanner.title': 'cookieBanner.title',
  'cookieBanner.acceptText': 'cookieBanner.acceptText',
  'header.forLabel': 'header.forLabel',
  'header.usefulLinksLabel': 'header.usefulLinksLabel',
  'footer.partnersLabel': 'footer.partnersLabel',
  'footer.worldCyclingPartnersLabel': 'footer.worldCyclingPartnersLabel',
  'footer.officialSupplierLabel': 'footer.officialSupplierLabel',
  'relatedContent.title': 'relatedContent.title',
  'competition.racesLabel': 'competition.racesLabel',
  'competition.classLabel': 'competition.classLabel',
  'competition.websiteLabel': 'competition.websiteLabel',
  'competition.emailLabel': 'competition.emailLabel',
  'competition.addressLabel': 'competition.addressLabel',
  'competition.assignmentsLabel': 'competition.assignmentsLabel',
  'competition.appointedByLabel': 'competition.appointedByLabel',
  'calendar.latestLabel': 'calendar.latestLabel',
  'calendar.upcomingLabel': 'calendar.upcomingLabel',
  'calendar.pastLabel': 'calendar.pastLabel',
  'calendar.raceHubLinkLabel': 'calendar.raceHubLinkLabel',
  'calendar.raceCategoryLabel': 'calendar.raceCategoryLabel',
  'calendar.raceTypeLabel': 'calendar.raceTypeLabel',
  'calendar.raceClassLabel': 'calendar.raceClassLabel',
  'calendar.eventTypeLabel': 'calendar.eventTypeLabel',
  'calendar.disciplineLabel': 'calendar.disciplineLabel',
  'calendar.raceYearLabel': 'calendar.raceYearLabel',
  'calendar.searchLabel': 'calendar.searchLabel',
  'calendar.searchText': 'calendar.searchText',
  'calendar.noResults': 'calendar.noResults',
  'calendar.viewMoreLabel': 'calendar.viewMoreLabel',
  'calendar.moreFiltersLabel': 'calendar.moreFiltersLabel',
  'calendar.noSearchResults': 'calendar.noSearchResults',
  'calendar.applyFiltersLabel': 'calendar.applyFiltersLabel',
  'calendar.downloadLabel': 'calendar.downloadLabel',
  'calendar.downloadSelectionLabel': 'calendar.downloadSelectionLabel',
  'calendar.downloadSeasonLabel': 'calendar.downloadSeasonLabel',
  'calendar.downloadHelpText': 'calendar.downloadHelpText',
  'competitionDetails.classLabel': 'competitionDetails.classLabel',
  'competitionDetails.websiteLabel': 'competitionDetails.websiteLabel',
  'competitionDetails.emailLabel': 'competitionDetails.emailLabel',
  'competitionDetails.scheduleTitle': 'competitionDetails.scheduleTitle',
  'competitionDetails.commissiaryTitle': 'competitionDetails.commissiaryTitle',
  'competitionDetails.commissiaryAppointedBy': 'competitionDetails.commissiaryAppointedBy',
  'filters.allFilterText': 'filters.allFilterText',
  'filters.allDisciplinesText': 'filters.allDisciplinesText',
  'filters.allSeasonsText': 'filters.allSeasonsText',
  'filters.allCountriesText': 'filters.allCountriesText',
  'filters.countryLabel': 'filters.countryLabel',
  'filters.seasonLabel': 'filters.seasonLabel',
  'filters.disciplineLabel': 'filters.disciplineLabel',
  'discipline.bmx': 'discipline.bmx',
  'discipline.cpt': 'discipline.cpt',
  'discipline.cro': 'discipline.cro',
  'discipline.ind': 'discipline.ind',
  'discipline.mtb': 'discipline.mtb',
  'discipline.par': 'discipline.par',
  'discipline.pis': 'discipline.pis',
  'discipline.roa': 'discipline.roa',
  'discipline.tri': 'discipline.tri',
  'discipline.gra': 'discipline.gra',
  'discipline.bfr': 'discipline.bfr',
  'discipline.ces': 'discipline.ces',
  'event.dayLabel': 'event.dayLabel',
  'event.liveNowLabel': 'event.liveNowLabel',
  'event.fromLabel': 'event.fromLabel',
  'event.upcomingLabel': 'event.upcomingLabel',
  'event.liveStreamLabel': 'event.liveStreamLabel',
  'event.liveScheduleLabel': 'event.liveScheduleLabel',
  'event.todaysEventsLabel': 'event.todaysEventsLabel',
  'event.watchPlaylistTitle': 'event.watchPlaylistTitle',
  'homepage.liveEventLabel': 'homepage.liveEventLabel',
  'riders.teamCategory': 'riders.teamCategory',
  'riders.searchText': 'riders.searchText',
  'riders.resultsLabel': 'riders.resultsLabel',
  'riders.teamsLabel': 'riders.teamsLabel',
  'riders.ridersLabel': 'riders.ridersLabel',
  'riders.dobLabel': 'riders.dobLabel',
  'riders.nationalityLabel': 'riders.nationalityLabel',
  'riders.sanctionsLabel': 'riders.sanctionsLabel',
  'regulations.overviewLabel': 'regulations.overviewLabel',
  'regulations.rulesInForceLabel': 'regulations.rulesInForceLabel',
  'regulations.upcomingAmendmentsLabel': 'regulations.upcomingAmendmentsLabel',
  'regulations.versionOnLabel': 'regulations.versionOnLabel',
  'regulations.inForceFromLabel': 'regulations.inForceFromLabel',
  'news.latest': 'news.latest',
  'news.noResultsText': 'news.noResultsText',
  'raceHub.commentaryViewMore': 'raceHub.commentaryViewMore',
  'search.searchLabel': 'search.searchLabel',
  'contact.title': 'contact.title',
  'contact.addr': 'contact.addr',
  'contact.tel': 'contact.tel',
  'contact.fax': 'contact.fax',
  'contact.email': 'contact.email',
  'contact.website': 'contact.website',
  'contact.twitter': 'contact.twitter',
  'rankingWidget.title': 'rankingWidget.title',
  'rankingWidget.pointsLabel': 'rankingWidget.pointsLabel',
  'rankingWidget.menLabel': 'rankingWidget.menLabel',
  'rankingWidget.womenLabel': 'rankingWidget.womenLabel',
  'rankingWidget.lastUpdatedLabel': 'rankingWidget.lastUpdatedLabel',
  'rankingWidget.noRankingsLabel': 'rankingWidget.noRankingsLabel',
  'technicalRankings.refineResultsLabel': 'technicalRankings.refineResultsLabel',
  'technicalRankings.searchTeamLabel': 'technicalRankings.searchTeamLabel',
  'technicalRankings.notesLabel': 'technicalRankings.notesLabel',
  'technicalRankings.notesMenDisclaimer': 'technicalRankings.notesMenDisclaimer',
  'technicalRankings.notesWomenDisclaimer': 'technicalRankings.notesWomenDisclaimer',
  'technicalRankings.title': 'technicalRankings.title',
  'technicalRankings.tableTotalLabel': 'technicalRankings.tableTotalLabel',
  'technicalRankings.tableTypeLabel': 'technicalRankings.tableTypeLabel',
};
